import React, { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import * as S from './Chip.styles';
import { ChipProps } from '@/components/UI/Chip/Chip.types';
import { cleanupSeoUrl } from '@/utils/helpers';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { useResponsive } from '@/hooks/useResponsive';
import { checkRoute } from '@/components/CustomLink/CustomLink.helpers';

export const Chip: React.FC<PropsWithChildren<ChipProps>> = ({
  children,
  appearance = 'default',
  size = 'l',
  isRounded,
  href,
  onClick,
  dataTestId,
  ...props
}) => {
  const router = useRouter();
  const { isDesktop } = useResponsive();

  const onLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (!href) return;

    const url = new URL(href, window.location.origin);

    url.searchParams.set('keywords_source', KeywordsSource.Typewritten);

    const newHref = `${url.pathname}?${url.searchParams.toString()}`;
    const { isInternal } = checkRoute(newHref, { isDesktop });

    if (isInternal) {
      router.push(newHref);
    } else {
      window.location.href = newHref;
    }
  };

  return (
    <S.ChipBox
      {...props}
      onClick={href ? onClick || onLinkClick : onClick}
      data-testid={dataTestId}
      {...(!!href && {
        as: CustomLink,
        href: cleanupSeoUrl(href),
        dataTestId,
      })}
      $appearance={appearance}
      $size={size}
      $isRounded={isRounded}
    >
      {children}
    </S.ChipBox>
  );
};
